export default {
  methods: {
    successAlert(message) {
      this.$store.commit("PUSH_ALERT", {variant: 'success', message: message})
    },
    dangerAlert(message) {
      this.$store.commit("PUSH_ALERT", {variant: 'danger', message: message})
    },
  }
}